__webpack_require__.p = "https://reviews-frontend.prtl.co/dist/";